import { memo, useCallback, useState } from 'react';
import { Image, StyleSheet } from 'react-native';
import { __WEB__ } from '../../constants/styles';
import TouchableOpacity from './form/touchable_opacity';

const CloseButton = memo((props) => {
  const { width, height, tintColor } = props;
  let iconStyle = width || height ? { width, height } : {};
  if (tintColor) iconStyle = { ...iconStyle, tintColor: tintColor };

  const [hovered, setHovered] = useState(false);
  const handleHoverIn = useCallback(() => {
    setHovered(true);
  }, []);
  const handleHoverOut = useCallback(() => {
    setHovered(false);
  }, []);

  return (
    <TouchableOpacity
      style={[styles.btn, props.style]}
      onPress={props.onPress}
      onHoverIn={__WEB__ ? handleHoverIn : null}
      onHoverOut={__WEB__ ? handleHoverOut : null}
      autoFocus={props.autoFocus}
      animated={props.animated}
      buttonConfig={props.buttonConfig}
    >
      <Image
        style={[styles.icon, iconStyle, hovered ? styles.hoveredIcon : null]}
        source={require('../../../resources/icon-close.png')}
        resizeMode="contain"
      />
    </TouchableOpacity>
  );
});
export default CloseButton;

const styles = StyleSheet.create({
  btn: {
    padding: 5,
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    width: 30,
    height: 30,
  },
  hoveredIcon: {
    tintColor: 'rgb(3, 153, 203)',
  },
});
